import { Switch, TriState } from "components";
import "./extra-work.scss";

interface ExtraWorkType {
  form: any;
  values: any;
}

const ExtraWork = ({ form, values }: ExtraWorkType) => {
  return (
    <div className="extra-work">
      <div className="am-section-heading">Dodatkowe prace</div>
      <div className="kwcc__switch">
        <label className="kwcc__label">Demontaż starych drzwi w całości</label>
        <Switch
          checked={values.oldDoorDismantling}
          name="oldDoorDismantling"
          form={form}
        />
      </div>
      <div className="kwcc__switch">
        <label className="kwcc__label">Zabezpieczenie podłogi/mebli</label>
        <TriState
          name="floorFurnitureProtection"
          first={{ name: "Inwestor", value: "investor" }}
          second={{ name: "Martdom", value: "martdom" }}
          third={{ name: "Nikt", value: "none" }}
          form={form}
        />
      </div>
      <div className="kwcc__switch">
        <label className="kwcc__label">
          Uprzątnięcie pomieszczeń - INWESTOR
        </label>
        <Switch
          checked={values.constructionSiteCleaningInvestor}
          name="constructionSiteCleaningInvestor"
          form={form}
        />
      </div>
    </div>
  );
};

export default ExtraWork;
